import { jsx, jsxs } from "react/jsx-runtime";
import { Tabs } from "@zillow/constellation-10";
import { isEditor } from "../../utils/isEditor.esm.js";
import { omitUndefined } from "../../utils/lodash.esm.js";
import { LOAN_PROGRAMS } from "../../utils/zhl-calculator.esm.js";
import CalculatorForm from "../CalculatorForm/CalculatorForm.esm.js";
import CalculatorLayout from "../CalculatorLayout/CalculatorLayout.esm.js";
import { handleFieldClickEvent } from "./VALoanCalculator.Clickstream.esm.js";
import { FieldConfig } from "./VALoanCalculator.utils.esm.js";
import VALoanCalculatorDonutChart from "./VALoanCalculatorDonutChart.esm.js";
import VALoanCalculatorFields from "./VALoanCalculatorFields.esm.js";
import VALoanCalculatorLineChart from "./VALoanCalculatorLineChart.esm.js";
const VALoanCalculator = ({
  defaultValues,
  isFHAEnabled = false,
  isMortgageComponent = false
}) => {
  const clickStreamBlockId = isMortgageComponent ? "mortgage_calc" : "va_mortgage_calc";
  const finalDefaultValues = {
    [FieldConfig.homePrice.name]: isMortgageComponent ? 225e3 : 3e5,
    [FieldConfig.loanProgram.name]: LOAN_PROGRAMS.fixed30Year,
    [FieldConfig.interestRate.name]: isMortgageComponent ? 5 : 4.176,
    [FieldConfig.downPayment.name]: isMortgageComponent ? 45e3 : 6e4,
    [FieldConfig.downPaymentPercent.name]: 20,
    [FieldConfig.homeInsurance.name]: isMortgageComponent ? 945 : Math.round(3e5 * 35e-5 * 12),
    [FieldConfig.hoa.name]: 0,
    [FieldConfig.taxRatePercent.name]: 1.2,
    [FieldConfig.taxRate.name]: 3600,
    [FieldConfig.includeTaxesInsurance.name]: true,
    [FieldConfig.includeMIP.name]: true,
    [FieldConfig.includePMI.name]: true,
    ...omitUndefined(defaultValues)
  };
  return /* @__PURE__ */ jsx(CalculatorForm, { fieldStorageKey: isFHAEnabled ? "FHAMortgageFields" : isMortgageComponent ? "MortgageCalculatorFields" : "VALoanCalculatorFields", calcTypeForMarketing: isFHAEnabled ? "FHAMortgage" : isMortgageComponent ? "MortgagePayment" : "VALoan", editorMode: isEditor(), defaultValues: finalDefaultValues, children: /* @__PURE__ */ jsx(CalculatorLayout, { fields: /* @__PURE__ */ jsx(VALoanCalculatorFields, { isFHAEnabled, isMortgageComponent }), content: /* @__PURE__ */ jsxs(Tabs.Root, { defaultSelected: "breakdown", children: [
    /* @__PURE__ */ jsxs(Tabs.List, { "aria-label": "VA loan calculator tabs", children: [
      /* @__PURE__ */ jsx(Tabs.Tab, { value: "breakdown", type: "button", onClick: () => !isFHAEnabled && handleFieldClickEvent("Breakdown", "tab", clickStreamBlockId), children: "Breakdown" }),
      /* @__PURE__ */ jsx(Tabs.Tab, { value: "schedule", type: "button", onClick: () => !isFHAEnabled && handleFieldClickEvent("Schedule", "tab", clickStreamBlockId), children: "Schedule" })
    ] }),
    /* @__PURE__ */ jsx(Tabs.Panel, { value: "breakdown", children: /* @__PURE__ */ jsx(VALoanCalculatorDonutChart, { isFHAEnabled, isMortgageComponent }) }),
    /* @__PURE__ */ jsx(Tabs.Panel, { value: "schedule", children: /* @__PURE__ */ jsx(VALoanCalculatorLineChart, {}) })
  ] }) }) });
};
export {
  VALoanCalculator as default
};
